import React from 'react';

import WorkspaceFilterPortal from './WorkspaceFilterPortal';
import { buildWorkspaceFilterSummaryLabels } from './workspaceDescriptorModel';
import { buildChartExportFilters } from '../chartShare/chartExportFilters';

let UnifiedFilterBarComponent = null;

const getUnifiedFilterBar = () => {
  if (!UnifiedFilterBarComponent) {
    UnifiedFilterBarComponent = require('../FilterBar').UnifiedFilterBar;
  }
  return UnifiedFilterBarComponent;
};

function WorkspaceFilterSurface({
  container,
  open,
  onToggle,
  filters,
  state,
  handlers,
  viewDescriptor,
  summaryLabels,
  exportFilters,
  leftContent,
  extraContent,
  maxWidth,
  maxControlWidth,
  isProUser,
  onUpgradeClick,
  showCollapseToggle = false,
  showSublabel = true,
  disabled = false,
}) {
  const resolvedSummaryLabels = summaryLabels || buildWorkspaceFilterSummaryLabels(viewDescriptor);
  const resolvedExportFilters = exportFilters || buildChartExportFilters({ filters, state });
  const UnifiedFilterBar = getUnifiedFilterBar();
  const filterBar = (
    <UnifiedFilterBar
      filters={filters}
      state={state}
      handlers={handlers}
      open={open}
      onToggle={onToggle}
      leftContent={leftContent}
      extraContent={extraContent}
      maxWidth={maxWidth}
      isProUser={isProUser}
      onUpgradeClick={onUpgradeClick}
      showCollapseToggle={showCollapseToggle}
      showSublabel={showSublabel}
      mode="workspaceTopBar"
    />
  );

  return (
    <WorkspaceFilterPortal
      container={container}
      open={open}
      filterBar={filterBar}
      summaryLabels={resolvedSummaryLabels}
      exportFilters={resolvedExportFilters}
      maxControlWidth={maxControlWidth}
      disabled={disabled}
    />
  );
}

export default WorkspaceFilterSurface;
